import { adminAPIService } from './index'

const route = 'brands'

export default {
  getList(params) {
    /**
     * Get trending feeds list
     * @param {object} params
      {
        page: number
        size: number
      }
    */
    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  create(detail, brand_profile_image) {
    // const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))
    if(brand_profile_image) {
      formData.append('brand_profile_image', brand_profile_image)
    }
    return adminAPIService({
      url: route,
      method: 'post',
      data: formData,
    })
  },
  update(detail, id, brand_profile_image) {
    // const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))
    if(brand_profile_image){
      formData.append('brand_profile_image', brand_profile_image)
    }
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: formData,
    })
  },
  delete(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'delete',
    })
  },
}
